// drawer/tabs/ThreatAssetsTab.tsx
import { Assets } from '@/sections/asset';
import type { EnrichedVulnerability } from '@/sections/threats/types';

enum TableName {
  ASSETS = 'threatIntelDrawerAssets',
}

interface ThreatAssetsTabProps {
  threatIntel?: EnrichedVulnerability;
}

/**
 * Assets Impacted tab — lists assets carrying a Risk for this vulnerability,
 * both directly (HAS_VULNERABILITY) and via webpages/ports. Matching is on
 * Risk.name === Vulnerability.id, an invariant enforced at every backend
 * risk-minting site, which also covers risks created before the INSTANCE_OF
 * backfill.
 */
export function ThreatAssetsTab({ threatIntel }: ThreatAssetsTabProps) {
  const vulnerabilityId = threatIntel?.id;

  if (!vulnerabilityId) {
    return (
      <p className="text-chariot-text-secondary text-sm">
        No information available at this time.
      </p>
    );
  }

  return (
    <div className="size-full">
      {/*
       * key={vulnerabilityId} — remount Assets on CVE change so
       * `keepPreviousData` in useQueryAssets cannot carry the previous CVE's
       * rows into the new CVE's table when the tab stays mounted (cached
       * drawer-data path: the drawer-level skeleton doesn't unmount the tab).
       */}
      <Assets
        key={vulnerabilityId}
        name={TableName.ASSETS}
        parentFilters={{ vulnerabilityId }}
        hideTitle
        inDrawer={true}
        hideBulkActions
        drawerFilters={['status', 'tags', 'attackSurface']}
        excludeDefaultColumns={['riskScore', 'type', 'created', 'visited']}
      />
    </div>
  );
}
